<template>
    <div v-loading="loading" class="page">
        <div class="describe-title"><h1>报考须知</h1></div>
        <div class="content" v-html="signData.ins_content"></div>
    </div>
</template>

<script>
    import IndexApi from '@/api/index.js';
    import { setCookie } from '@/utils/base.js';

    export default {
        data() {
            return {
                loading: true,
                signData: {},
            };
        },
        created() {
            // 获取数据
            this.getData();
        },
        methods: {
            // 获取数据
            getData() {
                let that = this;

                IndexApi.getSignSetting(true).then(res => {
                    that.signData = res.data.sign

                    that.loading = false;
                }).catch(error => {

                });
            },

            // 附件材料
            goFile(){
                this.$router.push({path: '/file'})
            },

            // 进入报名
            sign(){
                // 设置专业id
                setCookie('major_id', this.major_id);
                this.$router.push({path: '/instructions/index'})
            }
        }
    };
</script>

<style lang="scss" scoped>
    .page{
        background-color: #eee;
        padding: 20px;
    }
    .describe-title{
        text-align: center;
    }
    .content{
        padding: 30px;
        font-size: 18px;
    }
</style>



// WEBPACK FOOTER //
// src/views/instructions/index.vue